import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiArrowRight } = FiIcons;

export default function SectionHeader({ title, intro, buttonText, tagline }) {
  return (
    <div className="max-w-4xl mb-20">
      <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold text-deepNavy tracking-tight mb-8 leading-tight">
        {title}
      </h2>
      <p className="text-xl md:text-2xl text-deepNavy-light mb-10 leading-relaxed font-light">
        {intro}
      </p>
      <div className="flex flex-col sm:flex-row items-start sm:items-center gap-6">
        <button className="btn-primary group">
          {buttonText}
          <SafeIcon icon={FiArrowRight} className="ml-3 w-5 h-5 transition-transform duration-300 group-hover:translate-x-2" />
        </button>
        {tagline && (
          <span className="text-base font-medium text-mutedBlue italic">
            {tagline}
          </span>
        )}
      </div>
    </div>
  );
}